// ISO-ish week helpers (Monday-start) and month-week grouping
export function startOfWeek(date) {
  const d = new Date(date);
  const day = d.getDay(); // 0=Sun..6=Sat
  const diff = (day === 0 ? -6 : 1 - day); // shift to Monday
  d.setDate(d.getDate() + diff);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function endOfWeek(date) {
  const s = startOfWeek(date);
  s.setDate(s.getDate() + 6);
  return s;
}

export function monthRange(yyyymm) {
  // returns array of week objects within the given month "YYYY-MM"
  const [y, m] = yyyymm.split("-").map(Number);
  const first = new Date(y, m - 1, 1);
  const last = new Date(y, m, 0);
  const weeks = [];
  let cur = startOfWeek(first);
  let n = 1;
  while (cur <= last) {
    const e = endOfWeek(cur);
    weeks.push({
      label: `Week ${n}`,
      start: new Date(cur),
      end: new Date(e),
      key: `${y}-${m}-w${n}`,
      range: `${cur.toLocaleDateString(undefined, { day: "numeric", month: "short" })} – ${e.toLocaleDateString(undefined, { day: "numeric", month: "short" })}`,
    });
    n++;
    cur = new Date(cur);
    cur.setDate(cur.getDate() + 7);
  }
  return weeks;
}

export function dateToISO(d) {
  if (!d) return null;
  const dt = new Date(d);
  return dt.toISOString().slice(0, 10);
}

export function isInWeek(isoDate, week) {
  if (!isoDate) return false;
  const d = new Date(isoDate + "T00:00:00");
  return d >= week.start && d <= week.end;
}
